import dayjs from 'dayjs'
import * as validators from 'yup-intl-validator'

// ///////////////////////
// MARK: CONTEXT
export interface IAppSettingsState {
  timeZone: string
}

export interface IAppSettingsStateStored {
  timeZone: string
}

export interface IAppSettingsModel {}

export interface IAppSettingsFunctions {
  setTimeZone(value?: string): void
}

export interface IAppSettingsContext
  extends IAppSettingsState,
    IAppSettingsModel,
    IAppSettingsFunctions {}

export function getAppSettingsContext(): IAppSettingsModel {
  return {}
}

// ///////////////////////
// MARK: CONTEXT FUNCTIONS
export function getAppSettingsContextFunctions(
  state: IAppSettingsState,
  setState: React.Dispatch<React.SetStateAction<IAppSettingsState>>,
): IAppSettingsFunctions {
  return {
    setTimeZone(value) {
      setState((oldState) => ({
        ...oldState,
        timeZone: value ?? dayjs.tz.guess(),
      }))
    },
  }
}

// ///////////////////////
// MARK: INITIAL STATE
export function getAppSettingsInitialState(key = 'state_settings'): IAppSettingsState {
  const timeZone = dayjs.tz.guess()

  return {
    timeZone,
  }
}

export function parseAppSettingsState(value: IAppSettingsStateStored): IAppSettingsState {
  return {
    timeZone: value.timeZone,
  }
}

export function validateAppSettingsState(value: IAppSettingsStateStored): IAppSettingsState {
  return validators.object
    .schema(
      {
        timeZone: validators.string.schema(
          validators.i18n.DEFAULT_INTL,
          validators.string.isRequired(),
        ),
      },
      validators.i18n.DEFAULT_INTL,
      validators.object.isRequired(),
    )
    .validateSync(value) as unknown as IAppSettingsState
}
